export default {
    LOAD_VIDEO_FAILED: "Не удалось загрузить видео"
};
